mmf_modules.define('utils/touch',['require','exports','module'],function (require, exports, module) {

  var PRECISION = 30;

  var isInitialized = false;
  var isTouch = false;
  var currentX, currentY;
  var cachedX, cachedY;

  var touchevents = {
    touchstart: eventType('PointerDown') + ' touchstart',
    touchend: eventType('PointerUp') + ' touchend',
    touchmove: eventType('PointerMove') + ' touchmove'
  };

  function eventType (type) {
    return navigator.msPointerEnabled ? 'MS' + type : type.toLowerCase();
  }

  function setListener (elm, events, callback) {
    var eventsArray = events.split(' ');

    var len = eventsArray.length;
    while (len--) {
      elm.addEventListener(eventsArray[len], callback, false);
    }
  }

  function getPointerEvent (event) {
    return event.targetTouches ? event.targetTouches[0] : event;
  }

  function sendEvent (elm, eventName, originalEvent, data) {
    var customEvent = document.createEvent('Event');
    customEvent.originalEvent = originalEvent;
    data = data || {};
    data.x = currentX;
    data.y = currentY;
    data.distance = data.distance;

    if (customEvent.initEvent) {
      for (var key in data) {
        if ({}.hasOwnProperty.call(data, key)) {
          customEvent[key] = data[key];
        }
      }
      customEvent.initEvent(eventName, true, true);
      elm.dispatchEvent(customEvent);
    }
  }

  function onTouchStart (event) {
    if (event.type !== 'mousedown') { isTouch = true; }
    if (event.type === 'mousedown' && isTouch) { return; }

    var pointer = getPointerEvent(event);
    cachedX = currentX = pointer.pageX;
    cachedY = currentY = pointer.pageY;
  }

  function onTouchEnd (event) {
    if (event.type === 'mouseup' && isTouch) {
      isTouch = false;
      return;
    }

    var isTap = (
      cachedX >= currentX - PRECISION &&
      cachedX <= currentX + PRECISION &&
      cachedY >= currentY - PRECISION &&
      cachedY <= currentY + PRECISION
    );

    if (isTap) { sendEvent(event.target, 'tap', event); }
  }

  function onTouchMove (event) {
    if (event.type === 'mousemove' && isTouch) return;
    var pointer = getPointerEvent(event);
    currentX = pointer.pageX;
    currentY = pointer.pageY;
  }

  function init () {
    if (isInitialized) { return; }
    setListener(document, touchevents.touchstart, onTouchStart);
    setListener(document, touchevents.touchend, onTouchEnd);
    setListener(document, touchevents.touchmove, onTouchMove);
    isInitialized = true;
  }


  exports.init = init;
});

